import { ApiEndpoints } from "@shared/api/api-endpoints";
import { communicationApiClient } from "@shared/api/clients/apiClientFactory";

export const uxMessageActivityApi = {
  getMessageActivitySummary: async (utilityId: string) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      "communication-activity/summary",
      (query) => {
        query.push("remote_utility_id", utilityId);
      }
    );
    const response = await communicationApiClient.get(url);
    return response.data ?? [];
  },

  getAllMessageActivity: async (
    utilityId: string,
    page: number,
    limit: number,
    search?: string
  ) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      "communication-activity",
      (query) => {
        query.push("remote_utility_id", utilityId);
        query.push("page", page);
        query.push("limit", limit);
        if (search) {
          query.push("search_data", search);
        }
      }
    );
    const response = await communicationApiClient.get(url);
    return response.data ?? [];
  },
  getMessageActivityById: async (id: string, utilityId: string) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      `communication-activity/${id}`,
      (query) => {
        query.push("remote_utility_id", utilityId);
        query.push("is_extra_info", 1);
      }
    );
    const response = await communicationApiClient.get(url);
    return response.data ?? [];
  },
  resendActivity: async (payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      `communication-activity/${payload.id}/resend`
    );
    const response = await communicationApiClient.post(url, payload);
    return response.data || response.data.result;
  },
};
